var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"help",attrs:{"variant":"outline-info","title":_vm.text}},[_c('b-icon',{staticClass:"font-size-16",attrs:{"icon":"question","scale":"1.5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }